module.exports = __webpack_public_path__ + "img/angola.0b77a06a.svg";